import { render, staticRenderFns } from "./TasksCascadePopup.vue?vue&type=template&id=edf23da2&"
import script from "./TasksCascadePopup.vue?vue&type=script&lang=js&"
export * from "./TasksCascadePopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports